package br.com.vvrefeicoes.portal.data.repository

import br.com.vvrefeicoes.portal.domain.model.HomeAnnouncement
import br.com.vvrefeicoes.portal.domain.model.HomeData
import br.com.vvrefeicoes.portal.domain.repository.AuthRepository
import br.com.vvrefeicoes.portal.domain.repository.HomeRepository
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.header
import io.ktor.http.HttpHeaders
import io.ktor.http.isSuccess
import kotlinx.serialization.Serializable

class RemoteHomeRepository(
    private val httpClient: HttpClient,
    private val baseUrl: String,
    private val authRepository: AuthRepository,
) : HomeRepository {
    override suspend fun load(): HomeData {
        val response =
            httpClient.get("$baseUrl/home") {
                authRepository.session.value?.token?.let { token ->
                    header(HttpHeaders.Authorization, "Bearer $token")
                }
            }
        if (!response.status.isSuccess()) {
            error("HTTP ${response.status.value}")
        }
        return response.body<HomeResponseDto>().toDomain()
    }
}

@Serializable
private data class HomeResponseDto(
    val announcements: List<HomeAnnouncementDto> = emptyList(),
    val operationalComplete: Boolean = false,
    val purchasesComplete: Boolean = false,
) {
    fun toDomain() =
        HomeData(
            announcements = announcements.map { it.toDomain() },
            operationalComplete = operationalComplete,
            purchasesComplete = purchasesComplete,
        )
}

@Serializable
private data class HomeAnnouncementDto(
    val id: String,
    val title: String,
    val body: String,
    val imageUrl: String? = null,
    val publishedAt: String? = null,
    val authorName: String,
) {
    fun toDomain() =
        HomeAnnouncement(
            id = id,
            title = title,
            body = body,
            imageUrl = imageUrl,
            publishedAt = publishedAt,
            authorName = authorName,
        )
}
